<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Payment Terms</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">

        <div class="row">

            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblPaymentTerm" class="col-sm-4 col-form-label">Payment Term
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        <select id="ddlPaymentTerm" name="ddlPaymentTerm" [(ngModel)]="PaymentTermParams.Term" class="form-control">
                            <option value="Advance"> ADVANCE </option>
                            <option value="Credit"> CREDIT </option>
                        </select>
                    </div>

                </div>
            </div>


            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra">
                <div class="form-group row text-left">
                    <label for="lblPaymentAmount" class="col-sm-4 col-form-label">Amount <span
                            class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">

                        <div class="input-group">
                            <input class="form-control " name="txtPaymentAmount" [(ngModel)]="PaymentTermParams.Amount">

                        </div>


                    </div>
                </div>
            </div>

            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra">
                <div class="form-group row text-left">
                    <label for="lblSlipNumber" class="col-sm-4 col-form-label">Deposit Slip No.
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        <input class="form-control " name="txtSlipNumber" [(ngModel)]="PaymentTermParams.SlipNo">
                    </div>

                </div>
            </div>


            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra">
                <div class="form-group row text-left">
                    <label for="lblSplipDate" class="col-sm-4 col-form-label">Deposite Slip Date
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " placeholder="dd-mm-yyyy" [(ngModel)]="PaymentTermParams.SlipDate" name="txtSplipDate" ngbDatepicker
                                #d="ngbDatepicker">
                            <div class="input-group-append">
                                <button class="btn btn-light fa fa-calendar" (click)="d.toggle()"
                                    type="button"></button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra" >
                <div class="form-group row text-left">
                    <label for="lblCrDays" class="col-sm-4 col-form-label">Revenue Term
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        
                        <select id="ddlRevenueTerm" name="ddlRevenueTerm" [(ngModel)]="PaymentTermParams.RevenueTerm" class="form-control">
                            <option value="Against Delivery"> Against Delivery </option>
                            <option value="Against Delivery"> Against Installation </option>
                        </select>

                    </div>

                </div>
            </div>
            <div class="col-sm-6" *ngIf="PaymentTermParams.Term == 'Credit'" >
                <div class="form-group row text-left">
                    <label for="lblCrDays" class="col-sm-4 col-form-label">Credit ( No. Of Days)
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        <input class="form-control " type="number" name="txtCrDays" [(ngModel)]="PaymentTermParams.CreditDays">
                    </div>

                </div>
            </div>

            

            

            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra">
                <div class="form-group row text-left">
                    <label for="lblGeneralRemarks" class="col-sm-4 col-form-label">General Remarks (to be printed on
                        invoice)</label>
                    <div class="col-sm-8">
                        <input class="form-control " name="txtGeneralRemarks" [(ngModel)]="PaymentTermParams.GeneralRemark">
                    </div>

                </div>
            </div>

            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra">
                <div class="form-group row text-left">
                    <label for="lblBankGurantee" class="col-sm-4 col-form-label">Bank Gaurantee Required
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8">
                        <select id="ddlBankGurantee" name="ddlBankGurantee" class="form-control" [(ngModel)]="PaymentTermParams.BankGaurantee">
                            <option value=""> --Select-- </option>
                            <option value="Yes"> Yes </option>
                            <option value="No"> No </option>
                        </select>
                    </div>

                </div>
            </div>

            <div class="col-sm-6" *ngIf="!PaymentTermParams.IsForSpra">
                <div class="form-group row text-left">
                    <label for="lblBgNationalizedBank" class="col-sm-4 col-form-label">BG On Nationalized Bank
                        <span class="font-red-flamingo">*</span></label>
                    <div class="col-sm-8 ">
                        <div class="input-group">
                            <select id="ddlBgNationalizedBank" name="ddlBgNationalizedBank" class="form-control" [(ngModel)]="PaymentTermParams.BGOnNationalBank">
                                <option value=""> --Select-- </option>
                                <option value="Yes"> Yes </option>
                                <option value="No"> No </option>
                            </select>

                        </div>


                    </div>

                </div>
            </div>

        </div>


    </mat-card-content>
</mat-card>